import { useUpdateInvoiceCheck } from '@/hooks/api/1140_update_invoice_check';
import { toastApiError } from '@/lib/toast';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

export const InvoiceCheck = ({ disabled }: { disabled: boolean }) => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const { mutate, data, isPending, isSuccess, error } = useUpdateInvoiceCheck();
  const [checked, setChecked] = useState<boolean>(task!.invoice_checked);

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  const onCheck = (e: React.ChangeEvent) => {
    task!.invoice_checked = !task!.invoice_checked;
    setChecked((_) => task!.invoice_checked);

    setShowLoading(true);
    mutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      purchase_order_id: Number(purchase_order_id),
      task_id: task!.id,
      invoice_checked: task!.invoice_checked,
    });
  };

  return (
    <div className={`checklist-item ps-2 ms-3 ${task!.invoice_checked ? 'checklist-item-success' : 'checklist-item-secondary'}`}>
      <div className="d-flex align-items-start">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="invoice-check" checked={task!.invoice_checked} onChange={onCheck} disabled={disabled} />
        </div>
        <div>
          <label className="mb-0 text-dark font-weight-bold text-sm form-check-label" htmlFor="invoice-check">
            請求書チェック（{task!.business_partner_context.label}）
          </label>
          <div className="text-weak text-xs mt-1">請求書を確認し、問題なければチェックボックスをONにしてください。</div>
        </div>
      </div>
      {_w_!.invoice_manual_url && (
        <Link to={_w_!.invoice_manual_url} className="btn bg-gradient-secondary btn-sm ms-3 mt-3" target="_blank">
          確認マニュアル
        </Link>
      )}
    </div>
  );
};
